import {
  CropZoneMatchType,
  FilterFormikData
} from 'components/RecordsListView/types';

// Re-exported so existing importers of this module (apiHelpers, Components/types,
// PropertiesFilterSection tests) keep resolving the match-type enum from here.
export { CropZoneMatchType };

const initialValues: FilterFormikData = {
  dateRange: [],
  cropZoneIds: [],
  cropZones: [],
  totalArea: null,
  sourceType: null,
  matchType: CropZoneMatchType.ANY
};

export { initialValues };
export default initialValues;
